import ServerDirections from '@/config/server-directions'
import { Account } from '@/entities/Account'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

var snakeCaseKeys = require('snakecase-keys')

export class AccountRequests {
  get (id) {
    const route = ServerDirections.ACCOUNTS_ID.replace('{id}', id)
    const method = 'get'
    function map (data) {
      return new Account(data.account)
    }
    return requestService.makePromise(route, method, {}, map)
  }
  save (account) {
    const route = ServerDirections.ACCOUNTS
    const method = 'post'
    function map (data) {
      return data.id
    }
    const body = snakeCaseKeys(account)
    return requestService.makePromise(route, method, { body }, map)
  }
}
